/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Base_OnlyInputs */

const en_val_base_only = /** @type {(inputs: Val_Base_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base Only`)
};

const es_val_base_only = /** @type {(inputs: Val_Base_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo base`)
};

const fr_val_base_only = /** @type {(inputs: Val_Base_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base uniquement`)
};

const de_val_base_only = /** @type {(inputs: Val_Base_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Basis`)
};

const ja_val_base_only = /** @type {(inputs: Val_Base_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベース(本体)のみ`)
};

const zh_val_base_only = /** @type {(inputs: Val_Base_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅含底座/主体`)
};

const ar_val_base_only = /** @type {(inputs: Val_Base_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القاعدة فقط`)
};

const id_val_base_only = /** @type {(inputs: Val_Base_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya Dasar`)
};

const it_val_base_only = /** @type {(inputs: Val_Base_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo Base`)
};

const ru_val_base_only = /** @type {(inputs: Val_Base_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только база`)
};

const pt_val_base_only = /** @type {(inputs: Val_Base_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas Base`)
};

const ko_val_base_only = /** @type {(inputs: Val_Base_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`본체만 포함`)
};

/**
* | output |
* | --- |
* | "Base Only" |
*
* @param {Val_Base_OnlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_base_only = /** @type {((inputs?: Val_Base_OnlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Base_OnlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_base_only(inputs)
	if (locale === "es") return es_val_base_only(inputs)
	if (locale === "fr") return fr_val_base_only(inputs)
	if (locale === "de") return de_val_base_only(inputs)
	if (locale === "ja") return ja_val_base_only(inputs)
	if (locale === "zh") return zh_val_base_only(inputs)
	if (locale === "ar") return ar_val_base_only(inputs)
	if (locale === "id") return id_val_base_only(inputs)
	if (locale === "it") return it_val_base_only(inputs)
	if (locale === "ru") return ru_val_base_only(inputs)
	if (locale === "pt") return pt_val_base_only(inputs)
	return ko_val_base_only(inputs)
});